import { processCurrentMonthData, processCurrentPastMonthData } from "./daily-sales-processor";

interface SummaryData {
    dealer: string;
    items: { [model: string]: { [day: string]: number } };
}

interface DailyItem {
    name: string;
    days: { [key: number]: number };
    previousMonthTotal: number;
    currentPastMonthTotal?: number;
}

interface DealerData {
    name: string;
    models: string[];
    items: DailyItem[];
}

interface DealerSummary {
    dealer: string;
    walkIn: { ytd: number; periodoPrevio: number };
    sales: { ytd: number; periodoPrevio: number };
}

const WALK_IN = 'WALK IN';
const TEST_DRIVE = 'TEST DRIVE';

export class SummaryProcessor {
    private dealers: DealerData[] = [];

    constructor(
        private dayRange: { start: number; end: number },
        private initializeDays: () => { [key: number]: number }
    ) { }

    processData(dataType: 'current' | 'past', sourceData: SummaryData[] | undefined): void {
        (sourceData || []).forEach(dealerData => {
            const processMethod = dataType === 'current'
                ? processCurrentMonthData
                : processCurrentPastMonthData;

            processMethod(
                this.dealers,
                dealerData.dealer,
                dealerData.items,
                this.dayRange,
                this.initializeDays
            );
        });
    }

    getSummary(): DealerSummary[] {
        return this.dealers.map(dealer => {
            let walkInYTD = 0;
            let walkInPrevio = 0;
            let salesYTD = 0;
            let salesPrevio = 0;

            dealer.items.forEach(item => {
                const model = item.name.toUpperCase();
                const currentTotal = Object.values(item.days).reduce((a, b) => a + b, 0);

                if (model === WALK_IN) {
                    walkInYTD = currentTotal;
                    walkInPrevio = item.currentPastMonthTotal || 0;
                } else if (model !== TEST_DRIVE) {
                    salesYTD += currentTotal;
                    salesPrevio += item.currentPastMonthTotal || 0;
                }
            });

            return {
                dealer: dealer.name,
                walkIn: { ytd: walkInYTD, periodoPrevio: walkInPrevio },
                sales: { ytd: salesYTD, periodoPrevio: salesPrevio }
            };
        });
    }
}
